<template>
  <div id="top-header">
    <dv-decoration-8 class="header-left-decoration"/>
    <dv-decoration-5 class="header-center-decoration"/>
    <dv-decoration-8 class="header-right-decoration" :reverse="true"/>
    <div class="center-title">嗨小克产权管理有限公司智慧数据中心</div>
    <div class="btn" @click="toggle">
      <img class="btn-icon" src="@/components/datav/img/toggle.png" alt="">
      更多
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopHeader',
  data () {
    return {
      pageNum: 0,
    }
  },
  methods: {
    toggle () {
      if (this.pageNum === 0) {
        this.pageNum = 1
      } else {
        this.pageNum = 0
      }
      this.$emit('toggle', this.pageNum)
    }
  }
}
</script>

<style lang="less">
#top-header {
  position: relative;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;

  .header-center-decoration {
    width: 40%;
    height: 60px;
    margin-top: 30px;
  }

  .header-left-decoration, .header-right-decoration {
    width: 25%;
    height: 60px;
  }

  .center-title {
    position: absolute;
    font-size: 30px;
    font-weight: bold;
    left: 50%;
    top: 15px;
    transform: translateX(-50%);
  }

  .btn {
    cursor: pointer;
    font-size: 18px;
    line-height: 100px;
    margin-right: 20px;

    .btn-icon {
      width: 20px;
      height: 20px;
      display: inline-block;
    }

  }

}
</style>
